function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _excluded = ["title", "children", "storageID", "headerRight"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// This component should be refactored into a shared UI component
// @ts-nocheck
import { Component } from "react";
import h, { classed } from "@macrostrat/hyper";
import { Button, Collapse } from "@blueprintjs/core"; //import "./main.sass";

var HeaderButton = classed(Button, "ms-header-button");

var CollapsePanel = /*#__PURE__*/function (_Component) {
  _inherits(CollapsePanel, _Component);

  var _super = _createSuper(CollapsePanel);

  function CollapsePanel(props) {
    var _this;

    _classCallCheck(this, CollapsePanel);

    _this = _super.call(this, props);
    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(CollapsePanel, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      // Set open state from local storage if it is available
      var storageID = this.props.storageID;

      if (storageID == null) {
        return;
      }

      var isOpen = this.savedState()[storageID];

      if (isOpen == null) {
        return;
      }

      return this.setState({
        isOpen: isOpen
      });
    }
    /*
    Next functions are for state management
    across pages, if storageID prop is passed
    */

  }, {
    key: "savedState",
    value: function savedState() {
      try {
        var st = window.localStorage.getItem("collapse-panel-state");
        return JSON.parse(st) || {};
      } catch (error) {
        return {};
      }
    }
  }, {
    key: "checkLocalStorage",
    value: function checkLocalStorage() {
      // Set open state from local storage if it is available
      var storageID = this.props.storageID;

      if (storageID == null) {
        return;
      }

      var isOpen = this.savedState()[storageID] || null;

      if (isOpen == null) {
        isOpen = false;
      }

      return this.setState({
        isOpen: isOpen
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // Refresh object in local storage
      var storageID = this.props.storageID;

      if (storageID == null) {
        return;
      }

      var isOpen = this.state.isOpen;

      if (isOpen === prevState.isOpen) {
        return;
      }

      var s = this.savedState();
      s[storageID] = isOpen;
      var j = JSON.stringify(s);
      return window.localStorage.setItem("collapse-panel-state", j);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          title = _this$props.title,
          children = _this$props.children,
          storageID = _this$props.storageID,
          headerRight = _this$props.headerRight,
          props = _objectWithoutProperties(_this$props, _excluded);

      var isOpen = this.state.isOpen;
      var icon = isOpen ? "collapse-all" : "expand-all";

      var onClick = function onClick() {
        return _this2.setState({
          isOpen: !isOpen
        });
      };

      if (headerRight == null) {
        headerRight = null;
      }

      return h("div.collapse-panel", props, [h("div.panel-header", [h(HeaderButton, {
        icon: icon,
        minimal: true,
        onClick: onClick,
        fill: true
      }, [h("h2", title), h("span.expander")]), headerRight]), h(Collapse, {
        isOpen: isOpen
      }, children)]);
    }
  }]);

  return CollapsePanel;
}(Component);

_defineProperty(CollapsePanel, "defaultProps", {
  title: "Panel",
  // `storageID` prop allows storage of state in
  // localStorage or equivalent.
  storageID: null
});

export { CollapsePanel };